import { render, staticRenderFns } from "./SmartSurvey.vue?vue&type=template&id=0c54a0be&scoped=true&"
import script from "./SmartSurvey.vue?vue&type=script&lang=js&"
export * from "./SmartSurvey.vue?vue&type=script&lang=js&"
import style0 from "./SmartSurvey.vue?vue&type=style&index=0&id=0c54a0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54a0be",
  null
  
)

export default component.exports